import { DocumentNode, useMutation } from '@apollo/client';

import { graphql } from '../gql';
import { GET_RESERVES } from './reserves.query';

export const CLOSE_CLAIM = graphql(`
  mutation closeClaim($claimUuid: String!) {
    closeClaim(claimUuid: $claimUuid) {
      uuid
      referenceId
      status
    }
  }
`);

export interface CloseClaimInput {
  claimUuid: string;
}

export function useCloseClaimMutation() {
  const [closeClaimMutation, { loading, error }] = useMutation(
    CLOSE_CLAIM as unknown as DocumentNode,
    {
      refetchQueries: [GET_RESERVES, 'getClaimInformation'],
      awaitRefetchQueries: true,
    }
  );

  const closeClaim = async (claimInput: CloseClaimInput) => {
    const response = await closeClaimMutation({
      variables: {
        claimUuid: claimInput.claimUuid,
      },
    });
    return response.data?.closeClaim;
  };

  return {
    closeClaim,
    loading,
    error,
  };
}
